import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';

import { HandoverTokenDto } from './dtos/handover-token.dto';

@Injectable({ providedIn: 'root' })
export class PlatformSwitcherApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  /**
   * `access-token` is attached by the global auth interceptor, this call
   * needs no manual headers. See `api_platform` `POST /auth/handover-token`
   * (secure, Buyer-only).
   */
  public createHandoverToken(): Observable<HandoverTokenDto> {
    return this._http.post<HandoverTokenDto>(
      `${this._baseUrl}/auth/handover-token`,
      {},
      { context: withLoading('page') },
    );
  }
}
